import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { UserIntegrationForm } from '../models/user-integration/user-integration-form-item';

@Injectable({
  providedIn: 'root'
})
export class UserIntegrationService extends HttpBaseService{

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.UserIntegration, notifyServ, localizationService, configService);
  }

  getListByFilter(filter: any): Observable<UserIntegrationForm[]> {
    return this.post("GetListByFilter", filter, true);
  }

  save(obj: UserIntegrationForm): Observable<any> {
      return this.post("SaveAsync", obj, true);
  }
}